// extracted by mini-css-extract-plugin
export default {"storychestColor":"#dc3151","labelsPlusIcon":"labels_labelsPlusIcon__c2z1l","labelItem":"labels_labelItem__4IdpQ"};